// extracted by mini-css-extract-plugin
export var infoItem = "_o1-2";
export var title = "_o1-0";
export var value = "_o1-1";